import axios from './axios'
import {
	PDD_HEADER_PATI,
	PDD_HEADER_PAGE_CODE,
	buildPddRiskHeaders,
	setPddReadyWaiter
} from './pddRiskHeaders'

/**
 * 拼多多开放平台浏览器指纹流程
 * @see https://open.pinduoduo.com/application/document/browse?idStr=263992F97736A864
 *
 * 流程对齐官方示例：
 * 1) POST api/cloud_security/page_code 获取 PageCode（后端转调 pdd.cloud.isv.page.code）
 * 2) PDD_OPEN_init({ code: pagecode })
 * 3) PDD_OPEN_getPati() → window.pati
 * 4) 带 X-PDD-Pati / X-PDD-PageCode 请求检测接口（大小写严格）
 */

// 开平 ISV 前端插件检测页面 code 获取（相对 axios baseURL）
var PAGE_CODE_API = 'api/cloud_security/page_code'
// 平台检测是否携带指纹 Header（此前约定的生产/联调地址）
var PDD_INFO_URL = 'http://pdd1.zhidayd.com/info'

var bootstrapPromise = null

function extractPageCode(payload) {
	if (!payload) {
		return ''
	}
	if (payload.Response && payload.Response.PageCode) {
		return payload.Response.PageCode
	}
	if (payload.data && payload.data.Response && payload.data.Response.PageCode) {
		return payload.data.Response.PageCode
	}
	if (payload.data && (payload.data.PageCode || payload.data.page_code || payload.data.pagecode)) {
		return payload.data.PageCode || payload.data.page_code || payload.data.pagecode
	}
	if (payload.PageCode || payload.page_code || payload.pagecode) {
		return payload.PageCode || payload.page_code || payload.pagecode
	}
	return ''
}

function fetchPageCode() {
	return axios.post(PAGE_CODE_API, {
		url: typeof location !== 'undefined' ? location.href : ''
	}).then(function(res) {
		return extractPageCode(res && res.data)
	}).catch(function(err) {
		console.warn('[pddPati] fetch pagecode failed', err)
		return ''
	})
}

function initPddSdk(pagecode) {
	if (typeof window.PDD_OPEN_init !== 'function') {
		return Promise.resolve()
	}
	var options = pagecode ? { code: pagecode } : {}
	var result = window.PDD_OPEN_init(options)
	if (result && typeof result.then === 'function') {
		return result.catch(function() {
			return undefined
		})
	}
	return Promise.resolve()
}

function fetchPatiFromSdk() {
	if (typeof window.PDD_OPEN_getPati !== 'function') {
		return Promise.resolve('')
	}
	return window.PDD_OPEN_getPati().then(function(pati) {
		return pati || ''
	}).catch(function() {
		return ''
	})
}

/**
 * 完整初始化：pagecode → SDK init → pati，并写入 window
 * @returns {Promise<{pati: string, pagecode: string}>}
 */
export function bootstrapPddOpen() {
	if (bootstrapPromise) {
		return bootstrapPromise
	}

	bootstrapPromise = fetchPageCode().then(function(pagecode) {
		window.pagecode = pagecode || ''
		return initPddSdk(window.pagecode).then(function() {
			return fetchPatiFromSdk()
		}).then(function(pati) {
			window.pati = pati || ''
			return {
				pati: window.pati,
				pagecode: window.pagecode
			}
		})
	}).catch(function(err) {
		console.warn('[pddPati] bootstrap failed', err)
		window.pati = window.pati || ''
		window.pagecode = window.pagecode || ''
		return {
			pati: window.pati,
			pagecode: window.pagecode
		}
	})

	return bootstrapPromise
}

/**
 * 获取 pati（会先走完整 bootstrap，保证 pagecode 初始化）
 */
export function getPddPati() {
	return bootstrapPddOpen().then(function(result) {
		return result.pati || ''
	})
}

/**
 * 获取当前指纹 Header（未初始化则先 bootstrap）
 */
export function getPddRiskHeaders() {
	return bootstrapPddOpen().then(function(result) {
		return buildPddRiskHeaders(result.pati || '', result.pagecode || '')
	})
}

/**
 * 平台检测请求：校验是否携带 X-PDD-Pati / X-PDD-PageCode（大小写严格）
 */
export function reportPddInfo() {
	return getPddRiskHeaders().then(function(headers) {
		console.log('[pddPati] risk headers', {
			[PDD_HEADER_PATI]: headers[PDD_HEADER_PATI],
			[PDD_HEADER_PAGE_CODE]: headers[PDD_HEADER_PAGE_CODE]
		})
		return axios.post(PDD_INFO_URL, null, {
			headers: headers
		}).then(function(res) {
			console.log('[pddPati] info', res && res.data)
			return res
		}).catch(function(err) {
			console.warn('[pddPati] info request failed', err)
			return null
		})
	})
}

/**
 * 应用启动时调用：初始化指纹并上报检测接口
 */
export function initPddOpenAndReport() {
	return bootstrapPddOpen().then(function(result) {
		if (!result.pati && !result.pagecode) {
			return result
		}
		return reportPddInfo().then(function() {
			return result
		})
	})
}

// 供 axios 拦截器等待，保证业务请求在指纹就绪后再发出
setPddReadyWaiter(bootstrapPddOpen)



// WEBPACK FOOTER //
// ./src/libraries/utils/pddPati.js